import {inject, PLATFORM, customElement, bindable} from 'aurelia-framework';
import {AuthService} from '../../../services/auth-service';
import {I18N} from 'aurelia-i18n';

@customElement('language-switcher')
@inject(AuthService, I18N, Element)
export class languageSwitcher {
  @bindable currentLang='en';

  language_box_show: boolean;
  boxEventHandler: EventListener;

  constructor(public authService: AuthService, public i18n: I18N, public cElement: Element) {
    this.i18n = i18n;
    this.authService = authService;
    this.language_box_show = true;
    this.hideBox();
    this.boxEventHandler = e => {
      const targetName = (e.target as HTMLElement).className;
      switch(targetName) {
        case 'languages-box au-target':
          break;
        case 'language au-target':
          this.changeLanguage(e);
          break;
        default:
          this.hideBox();
      }
      if(targetName === "languages-box au-target") {

      }
    }
  }
  bind() {
    //setting language
    this.setLanguage();
    PLATFORM.addEventListener('load', () => this.setLanguage());
    this.highlightSelected();
  }
  boxDisplay() {
    document.addEventListener('click', this.boxEventHandler);
    this.language_box_show  = !this.language_box_show;
    this.highlightSelected();
  }
  hideBox() {
    document.removeEventListener('click', this.boxEventHandler);
    this.language_box_show  = false;
  }
  changeLanguage(event) {
    let element = (event.target && event.target.tagName != 'DIV') ? event.target.parentElement : event.target;
    if (element.id != this.currentLang) {
      this.authService.changeLanguage(element.id);
      this.highlightSelected();
    }
  }
  setLanguage() {
    this.i18n.setLocale(this.currentLang);
  }

  highlightSelected() {
    console.log(this.cElement);
    let selectedElement = this.cElement.querySelector('#' + this.currentLang);
    let languageElements = this.cElement.querySelectorAll('.language');
    for (let i = 0; i < languageElements.length; i++) {
      languageElements[i].classList.remove('selected');
    }
    selectedElement.classList.add('selected');
  }

}
